import React from "react";
import { EditorialSplitCoursePage } from "./CoursePageDesignsCore";
import MetaInfo from "./components/MetaInfo";
import Header from "./components/Header";
import Footer from "./components/Footer";

export default function CourseDetails4(props) {
    return (
        <>
            <MetaInfo />
            <Header school="common" />
            <EditorialSplitCoursePage {...props} />;
            <Footer />
        </>
    )
};
